// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fj0qJOc0EuQv0OtN {
  width: 208px;
  height: 126px;
  border-radius: 8px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #dfe3e7;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  position: absolute;
}
.mssKM7ecJaoSaieP {
  padding: 16px 24px 0;
}
.Jdh9UjdPo48FofJl {
  display: flex;
  font-size: 12px;
  line-height: 18px;
  color: #333333;
}
.i4OoZVtD0csQvPwK {
  width: 50px;
  text-align: right;
  font-weight: bold;
  margin-right: 8px;
}
.oROAvwIEgD4WyGWg {
  color: #333333;
}
.GToMDPtNjcMqQ6m8 {
  line-height: 39px;
  border-top: 1px solid #DFE3E7;
  text-align: center;
  color: #0095FC;
  font-size: 12px;
  margin-top: 16px;
  user-select: none;
}
.GToMDPtNjcMqQ6m8 > span {
  cursor: pointer;
}
.zhq0ZREKc8lq17qN {
  color: #4CDE67;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/CardInfo/index.modules.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,8CAAA;EACA,eAAA;EACA,kBAAA;AACF;AACA;EACI,oBAAA;AACJ;AACA;EACI,aAAA;EACA,eAAA;EACA,iBAAA;EAGA,cAAA;AADJ;AAGA;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AADJ;AAGA;EACI,cAAA;AADJ;AAIA;EACI,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAFJ;AALA;EASQ,eAAA;AADR;AAIA;EACI,cAAA;AAFJ","sourcesContent":[".CardInfo {\n  width: 208px;\n  height: 126px;\n  border-radius: 8px;\n  background: #ffffff;\n  box-sizing: border-box;\n  border: 1px solid #dfe3e7;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);\n  font-size: 12px;\n  position: absolute;\n}\n.cardTop {\n    padding: 16px 24px 0;\n}\n.cardinfoItem {\n    display: flex;\n    font-size: 12px;\n    line-height: 18px;\n   \n    \n    color: #333333;\n}\n.cardTit {\n    width: 50px;\n    text-align: right;\n    font-weight: bold;\n    margin-right: 8px\n}\n.cardVal {\n    color: #333333;\n\n}\n.cardBottom {\n    line-height: 39px;\n    border-top: 1px solid #DFE3E7;\n    text-align: center;\n    color: #0095FC;\n    font-size: 12px;\n    margin-top: 16px;\n    user-select: none;\n    > span {\n        cursor: pointer;\n    }\n}\n.bulue {\n    color:#4CDE67;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CardInfo": `fj0qJOc0EuQv0OtN`,
	"cardTop": `mssKM7ecJaoSaieP`,
	"cardinfoItem": `Jdh9UjdPo48FofJl`,
	"cardTit": `i4OoZVtD0csQvPwK`,
	"cardVal": `oROAvwIEgD4WyGWg`,
	"cardBottom": `GToMDPtNjcMqQ6m8`,
	"bulue": `zhq0ZREKc8lq17qN`
};
export default ___CSS_LOADER_EXPORT___;
